import { connect } from 'react-redux';

import { makeGetCurrentUser } from 'selectors/users';

import { canUser } from 'services/permissions-service';

const CanUser = ({ type, reverse, customList, user, children }) => {
    if (canUser(type, customList, user) && !reverse) {
        return children;
    }
    if (!canUser(type, customList, user) && reverse) {
        return children;
    }

    return null;
}

const makeMapStateToProps = () => {
    const getCurrentUser = makeGetCurrentUser();

    return ({ users }, ownProps) => {
        return {
            user: ownProps.user || getCurrentUser(users)
        }
    }
}

export default connect(makeMapStateToProps)(CanUser);
